import React, { useState } from "react";
import { connect } from "react-redux";
import { pageActions } from "../../actions";

function PageTypeDropdown(props) {
  const { editPage, pagetypes, org, handler, afterHandler } = props;
  const dropdown = pagetypes.dropdown;

  const [page] = useState(props.page);
  const [selectedType, setSelectedType] = useState(props.selectedType);

  const onChangeType = (type) => {
    if (handler) {
      handler(type);
    }
    setSelectedType(type);
    page.page_type_id = parseInt(type, 10);
    page.org_id = org?.current_org_id;

    editPage(page);
    if (afterHandler) {
      afterHandler(type);
    }
  };

  return (
    <div>
      {dropdown && selectedType && (
        <select
          value={selectedType}
          onChange={(e) => onChangeType(e.target.value)}
        >
          {dropdown.map((item) => (
            <option value={item.value} key={item.value}>{item.display}</option>
          ))}
        </select>
      )}
    </div>
  );
}

const actionCreators = {
  editPage: pageActions.editPage,
};

function mapStateToProps(state) {
  const { authentication, pagetypes, org } = state;
  return {
    authentication,
    pagetypes,
    org,
  };
}

const connectedPTD = connect(mapStateToProps, actionCreators)(PageTypeDropdown);
export { connectedPTD as PageTypeDropdown };
